import { env } from 'app/lib/env';
import { useUser } from 'app/network/user';
import { i18n } from 'app/localization/i18n';

export function useDistanceUnit() {
  const user = useUser();

  const shouldUseMiles = (() => {
    return user.data?.distanceUnit === 'mi' || env.IS_PARTAKE;
  })();

  const unit = shouldUseMiles ? 'mi' : 'km';

  const convertDistance = (
    distanceInMeters: number,
    options?: { forceMiles?: boolean; alreadyInKm?: boolean; withUnit?: boolean },
  ) => {
    const useMiles = options?.forceMiles ?? shouldUseMiles;

    const km = options?.alreadyInKm ? distanceInMeters : distanceInMeters / 1000;
    const distance = useMiles ? (km * 1000) / 1609.34 : km;
    const suffix = options?.withUnit ? (useMiles ? ' mi' : ' km') : '';
    return `${distance.toFixed(0)}${suffix}`;
  };

  const formatDistance = (distanceInMeters = 0, noText = false): string => {
    const threshold = shouldUseMiles ? 1609.34 : 1000;

    if (distanceInMeters > threshold) {
      return convertDistance(distanceInMeters, { withUnit: true });
    }

    if (noText) {
      return `< 1 ${unit}`;
    }

    return i18n.t('headerSection.lessThanKm', {
      ns: 'one-listing',
      distance: 1,
      unit: unit,
    });
  };

  const formatDistanceWithoutText = (distanceInMeters = 0): string => {
    return formatDistance(distanceInMeters, true);
  };

  return {
    convertDistance,
    unit,
    formatDistance,
    formatDistanceWithoutText,
  };
}
